import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getAllQueryParam, removeURLParameter } from '@helpers/url'
import { setHeader } from '@helpers/index'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Icon from '@components/icons'
import * as Yup from 'yup'
import notification from '@components/notification'
import styles from '../index.module.scss'
import Tooltip from '@components/tooltip'
import _ from 'lodash'
import { segmentEventTrack } from '@helpers/segment'

const mapDispatchToProps = ({ auth }) => {
  return {
    ...auth
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    ...auth
  }
}
const star = ['Hated it', "Didn't like it", 'Just OK', 'Liked it', 'Loved it']
class reviewFeedback extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      queryData: {},
      showForm: true,
      message: '',
      review: {},
      clientEmail: '',
      No_alg_data: false,
      feedbackType: 'good',
      newReviewsFlag: false
    }
  }

  async componentDidMount() {
    const queryData = getAllQueryParam()
    const segmentData = {
      event: 'end_user_review_request_opened',
      properties: {
        businessName: queryData.bn && decodeURIComponent(queryData.bn)
      }
    }
    await segmentEventTrack(segmentData)
    await this.props.getReviewSettings(queryData)

    const newReviewsFlag = _.get(this.props, 'review_settings.newReviewsFlag', false)
    this.setState({ queryData, newReviewsFlag: newReviewsFlag })

    if (newReviewsFlag) {
      this.newReviewInit()
      return
    }

    this.init()
  }

  async init() {
    if (!this.props.domainSettings) await this.props.validateDomain()

    const queryData = getAllQueryParam()
    this.setState({ queryData })
    setHeader(this.props.domainSettings, 'Submit Review')
    if (queryData.ps) {
      this.setState({ preScreen: true })
    } else {
      this.setState({ preScreen: false })
    }

    if (queryData.rtype === 'pwa') {
      this.setState({ newscreen: true })
      if (queryData.rt === 'b') {
        this.setState({ typeStatus: 'sad' })
      } else {
        this.setState({ typeStatus: 'happy' })
      }
    } else {
      this.setState({ newscreen: false })
    }

    if (queryData.direct) {
      const obj = Object.assign(this.state.review)
      obj.rating = 5
      this.setState({ directLinkClicked: true, review: obj })
    } else {
      this.setState({ directLinkClicked: false })
    }
    if (queryData.rt === 'b') {
      this.setState({ feedbackType: 'bad' })
    }
    let reviewFrom = ''
    if (queryData.skp && queryData.skp === 't') {
      reviewFrom = 'widget'
      if (queryData.r) {
        if (queryData.ph) {
          reviewFrom = 'phone'
        } else {
          reviewFrom = 'email'
        }
        this.checkValid()
      } else {
        this.checkCommonValid()
      }
    } else if (queryData.r) {
      if (queryData.ph) {
        reviewFrom = 'phone'
      } else {
        reviewFrom = 'email'
      }
      this.checkValid()
    } else if (queryData.wid) {
      reviewFrom = 'widget'
      this.checkCommonValid()
    } else if (queryData.uid) {
      reviewFrom = 'widget'
      this.checkCommonValid()
    } else {
      await this.setState({
        screenType: 'message',
        showNewDesign: false,
        showForm: false,
        message: 'Sorry, the feedback link has already been used or it has expired.',
        loaded: true
      })
    }
    await this.setState({ reviewFrom: reviewFrom })
  }

  async getReviewSettings() {
    await this.props.getReviewSettings(this.state.queryData)
    if (
      this.props.review_settings &&
      this.props.review_settings.review_request_type === 'prescreen_with_alg' &&
      this.state.showFstForm &&
      !this.state.alg_data &&
      !this.state.queryData.rtype &&
      !this.state.queryData.direct
    ) {
      await this.setState({ showFstForm: false })
    }
    if (
      this.props.review_settings &&
      this.props.review_settings.review_request_type !== 'prescreen_with_alg' &&
      !this.state.newscreen &&
      this.state.feedbackType === 'good' &&
      this.state.showForm &&
      !this.state.directLinkClicked &&
      !this.state.showFstForm &&
      !this.state.preScreen
    ) {
      await this.setState({ hideOldDesign: true })
    } else {
      await this.setState({ hideOldDesign: false })
    }
    await this.getDesign()
    this.setState({ loaded: true })
  }

  async getDesign() {
    if (
      ((this.props.review_settings && this.props.review_settings.review_request_type === 'prescreen_with_alg') ||
        this.state.newscreen) &&
      !this.state.showFstForm &&
      !this.state.directLinkClicked
    ) {
      await this.setState({ showNewDesign: true })
      if (!this.state.typeStatus && this.state.showForm) {
        await this.setState({ screenType: 'smiley' })
      } else if (this.state.typeStatus === 'sad' && this.state.showForm) {
        await this.setState({ screenType: 'form' })
      } else if (this.state.typeStatus === 'happy' && this.state.showForm) {
        await this.setState({ screenType: 'review-links' })
      } else if (!this.state.showForm) {
        await this.setState({ screenType: 'message' })
      }
    }
    if (
      this.props.review_settings &&
      this.props.review_settings.review_request_type !== 'prescreen_with_alg' &&
      !this.state.newscreen &&
      this.state.feedbackType === 'good' &&
      this.state.showForm &&
      !this.state.directLinkClicked &&
      !this.state.showFstForm &&
      !this.state.preScreen
    ) {
      await this.setState({ showNewDesign: true, screenType: 'review-links' })
    } else if (
      (this.props.review_settings &&
        this.props.review_settings.review_request_type !== 'prescreen_with_alg' &&
        !this.state.newscreen &&
        !this.state.hideOldDesign) ||
      this.state.directLinkClicked ||
      this.state.showFstForm
    ) {
      if (this.state.showForm) {
        if (!this.state.preScreen && this.state.showFstForm) {
          await this.setState({ screenType: 'form' })
        } else {
          await this.setState({ screenType: 'smiley' })
        }
      } else {
        if (this.state.thirdpartyLinks) {
          await this.setState({ screenType: 'review-links' })
        } else {
          await this.setState({ screenType: 'message' })
        }
      }
      await this.setState({ showNewDesign: false })
    }
  }

  async checkValid() {
    const data = {
      review_id: this.state.queryData && this.state.queryData.r,
      exp_time: this.state.queryData && this.state.queryData.ed,
      review_type: this.state.queryData.rt && this.state.queryData.rt === 'g' ? 'good' : 'bad',
      url: window.location.href.replace('&ps=ps', '')
    }
    if (this.state.queryData.skp) {
      data.skip_alg = true
    }
    if (this.state.queryData.nxt) {
      data.next_step = true
    }
    if (this.state.queryData.ph) {
      data.contact_number = this.state.queryData.ph
    }
    if (this.state.queryData.e) {
      data.contact_email = this.state.queryData.e
    }
    await this.props.getFeedbackStatus(data)
    console.log('this.props.feedback_status-->', this.props.feedback_status)
    if (
      this.props.feedback_status &&
      this.props.feedback_status.message &&
      this.props.feedback_status.message.toLowerCase() === 'valid link' &&
      !this.props.feedback_status.alg_data
    ) {
      let showFstForm
      if (this.state.queryData.direct) {
        showFstForm = true
      } else if (this.state.queryData.rtype === 'pwa' && this.state.queryData.rt && this.state.queryData.rt === 'g') {
        showFstForm = true
      } else if (this.state.queryData.rtype === 'pwa' && this.state.queryData.rt && this.state.queryData.rt === 'b') {
        showFstForm = false
      } else if (this.state.queryData.rtype === 'nopwa') {
        showFstForm = true
      } else {
        showFstForm = true
      }
      await this.setState({ showFstForm: showFstForm, No_alg_data: true })
    } else if (
      this.props.feedback_status &&
      this.props.feedback_status.message &&
      this.props.feedback_status.message.toLowerCase() === 'valid link' &&
      this.props.feedback_status.alg_data
    ) {
      await this.setState({ showForm: true, alg_data: this.props.feedback_status.alg_data })
      // if (this.state.alg_data.secondary_links && this.state.alg_data.secondary_links.length) {
      //     this.setState({ limitcount: this.state.alg_data.secondary_links.length });
      // }
    } else if (
      this.props.feedback_status &&
      this.props.feedback_status.error &&
      this.props.feedback_status.data &&
      this.props.feedback_status.data.length > 0
    ) {
      await this.setState({ showForm: false, thirdpartyLinks: this.props.feedback_status.data })
    } else {
      await this.setState({
        showForm: false,
        message: 'Sorry, the feedback link has already been used or it has expired.'
      })
    }
    if (this.props.feedback_status && this.props.feedback_status.email) {
      await this.setState({ clientEmail: this.props.feedback_status.email })
    }
    await this.getReviewSettings()
    if (this.props.apiError) {
      this.setState({ showForm: false, message: 'Sorry, the feedback link has already been used or it has expired.' })
    }
  }

  async checkCommonValid() {
    const data = {
      url: window.location.href.replace('&ps=ps', '')
    }
    if (this.state.queryData.wid) {
      data.wid = this.state.queryData.wid
    } else if (this.state.queryData.uid) {
      data.uid = this.state.queryData.uid
    }

    if (this.state.queryData.pid) {
      data.pid = this.state.queryData.pid
    }

    if (this.state.queryData.skp) {
      data.skip_alg = true
    }
    await this.props.getCommonFeedbackStatus(data)
    if (
      this.props.common_feedback_status &&
      this.props.common_feedback_status.message &&
      this.props.common_feedback_status.message === 'valid link' &&
      !this.props.common_feedback_status.alg_data
    ) {
      let showFstForm
      if (this.state.queryData.direct) {
        showFstForm = true
      } else if (this.state.queryData.rtype === 'pwa' && this.state.queryData.rt && this.state.queryData.rt === 'g') {
        showFstForm = true
      } else if (this.state.queryData.rtype === 'pwa' && this.state.queryData.rt && this.state.queryData.rt === 'b') {
        showFstForm = false
      } else if (this.state.queryData.rtype === 'nopwa') {
        showFstForm = true
      } else {
        showFstForm = true
      }
      await this.setState({ showFstForm: showFstForm, No_alg_data: true })
    } else if (
      this.props.common_feedback_status &&
      this.props.common_feedback_status.message &&
      this.props.common_feedback_status.message === 'valid link' &&
      this.props.common_feedback_status.alg_data
    ) {
      await this.setState({ showForm: true, alg_data: this.props.common_feedback_status.alg_data })
      // if (this.state.alg_data.secondary_links && this.state.alg_data.secondary_links.length) {
      //     this.setState({ limitcount: this.state.alg_data.secondary_links.length });
      // }
    } else if (
      this.props.common_feedback_status &&
      this.props.common_feedback_status.error &&
      this.props.common_feedback_status.data &&
      this.props.common_feedback_status.data.length > 0
    ) {
      await this.setState({ showForm: false, thirdpartyLinks: this.props.common_feedback_status.data })
    } else {
      await this.setState({
        showForm: false,
        message: 'Sorry, the feedback link has already been used or it has expired.'
      })
    }
    await this.getReviewSettings()
    if (this.props.apiError) {
      this.setState({ showForm: false, message: 'Sorry, the feedback link has already been used or it has expired.' })
    }
  }

  async newReviewInit() {
    if (!this.props.domainSettings) {
      await this.props.validateDomain()
    }

    setHeader(this.props.domainSettings, 'Submit Review')

    const data = {
      url: window.location.href.replace('&ps=ps', '')
    }

    if (this.state.queryData.wid) {
      data.wid = this.state.queryData.wid
    }

    if (this.state.queryData.uid) {
      data.uid = this.state.queryData.uid
    }

    if (this.state.queryData.pid) {
      data.pid = this.state.queryData.pid
    }

    if (this.state.queryData.r) {
      data.review_id = this.state.queryData.r
    }

    if (this.state.queryData.e) {
      data.email = this.state.queryData.e
    }

    if (this.state.queryData.ph) {
      data.phone = this.state.queryData.ph
    }

    await this.props.getCommonFeedbackStatus(data)
    if (!this.props.common_feedback_status) {
      this.setState({
        loaded: true,
        showForm: false,
        screenType: 'message',
        message: 'Sorry, the feedback link has already been used or it has expired.'
      })
      return
    }
    const algData = _.get(this.props, 'common_feedback_status.alg_data', undefined)
    const isDirectReview = _.get(this.state, 'queryData.direct', undefined)

    const shouldInsertDirectLink = algData === undefined && !isDirectReview
    const shouldUseAlgFromApi = algData !== undefined && !isDirectReview
    if (shouldInsertDirectLink) {
      this.setState({
        alg_data: {
          primary_link: {
            first_party: true,
            image:
              'https://d1hz0qcu1muexe.cloudfront.net/uploads/58db9ace0736dc11398ff005/520baa363e81edf22d10e31f0f86f445favicon.png',
            reviewed: 3,
            site: 'direct',
            urls: `${window.location.href}&skp=t`,
            weight: 1
          },
          secondary_links: []
        }
      })
    }

    if (shouldUseAlgFromApi) {
      this.setState({
        alg_data: algData
      })
    }

    this.setState({
      showNewDesign: !this.state.queryData.direct,
      newscreen: false,
      prescreen: false,
      feedbackType: 'good',
      No_alg_data: false,
      showFstForm: true,
      showForm: true,
      hideOldDesign: true,
      loaded: true,
      screenType: this.state.queryData.direct ? 'form' : 'review-links'
    })
  }

  createMarkup() {
    return { __html: this.props.review_settings && this.props.review_settings.comment }
  }

  createReviewTextMarkup() {
    return { __html: this.props.review_settings && this.props.review_settings.review_text }
  }

  createNegativeTextMarkup() {
    return { __html: this.props.review_settings && this.props.review_settings.negative_review_text }
  }

  async happyFeedBack() {
    if (this.state.No_alg_data) {
      await this.setState({ preScreen: false, showFstForm: true })
    } else {
      const obj = Object.assign(this.state.review)
      obj.rating = 5
      await this.setState({ feedbackType: 'good', typeStatus: 'happy', review: obj })
    }
    await this.getDesign()
  }

  async sadFeedBack() {
    await this.setState({ preScreen: false, feedbackType: 'bad', typeStatus: 'sad' })
    await this.getDesign()
  }

  async goodFeedBack() {
    await this.setState({ preScreen: false, feedbackType: 'good', typeStatus: 'old' })
    if (
      this.props.review_settings &&
      this.props.review_settings.review_request_type !== 'prescreen_with_alg' &&
      !this.state.newscreen &&
      this.state.feedbackType === 'good' &&
      this.state.showForm &&
      !this.state.directLinkClicked &&
      !this.state.showFstForm &&
      !this.state.preScreen
    ) {
      await this.setState({ hideOldDesign: true })
    } else {
      await this.setState({ hideOldDesign: false })
    }
    await this.getDesign()
  }

  async redirectToThridPartyLinks(link, type) {
    let url = link.urls
    const trackId = link.track_id
    if (link && link.site && link.site === 'direct') {
      url = url + '&direct=true'
      url = removeURLParameter(url, 'rms')
      console.log(url)
    }
    const segmentData = {
      event: 'end_user_review_clicked',
      properties: {
        businessName: this.state.queryData.bn && decodeURIComponent(this.state.queryData.bn),
        reviewMethod: link.site
      }
    }
    await segmentEventTrack(segmentData)
    if (trackId) {
      window.open(url, '_self')
    } else {
      window.open(url, '_self')
    }
  }

  getPrimaryLinks(link) {
    if (link.primary_link.site === 'direct') {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src="https://gosite-assets.s3-us-west-1.amazonaws.com/image/social/2/website.svg"
            alt=""
          />
          <span> DIRECT REVIEW</span>
        </Fragment>
      )
    } else if (link.primary_link.site === 'google my business') {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src="https://dufzo4epsnvlh.cloudfront.net/image/presence/large/icon-google.png"
            alt=""
          />
          <span> GOOGLE</span>
        </Fragment>
      )
    } else if (
      link.primary_link.site === 'other' &&
      link.primary_link.image &&
      link.primary_link.site !== 'google my business'
    ) {
      return (
        <Fragment>
          <img src={link.primary_link.image} alt="" />
          {link.primary_link.site_name ? (
            <span className="text-uppercase">{link.primary_link.site_name}</span>
          ) : (
            <span> GOOGLE</span>
          )}
        </Fragment>
      )
    } else if (link.primary_link.site === 'direct_gmb') {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src={`https://dufzo4epsnvlh.cloudfront.net/image/presence/large/icon-${link.primary_link.site}.png`}
            alt=""
          />
          <span className="text-uppercase">Rate us on Google</span>
        </Fragment>
      )
    } else if (link.primary_link.site_name) {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src={`https://dufzo4epsnvlh.cloudfront.net/image/presence/large/icon-${link.primary_link.site}.png`}
            alt=""
          />
          <span className="text-uppercase">{link.primary_link.site_name}</span>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src={`https://dufzo4epsnvlh.cloudfront.net/image/presence/large/icon-${link.primary_link.site}.png`}
            alt=""
          />
          <span className="text-uppercase">{link.primary_link.site}</span>
        </Fragment>
      )
    }
  }

  getSecondaryLinks(link) {
    if (link.site === 'direct') {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src="https://gosite-assets.s3-us-west-1.amazonaws.com/image/social/2/website.svg"
            alt=""
          />
          <span> DIRECT REVIEW</span>
        </Fragment>
      )
    } else if (link.site === 'facebook') {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src="https://gosite-assets.s3-us-west-1.amazonaws.com/image/social/2/facebook.svg"
            alt=""
          />
          {link.site_name ? (
            <span className="text-uppercase">{link.site_name}</span>
          ) : link.site ? (
            <span className="text-uppercase">{link.site}</span>
          ) : (
            ''
          )}
        </Fragment>
      )
    } else if (link.site === 'google my business') {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src="https://dufzo4epsnvlh.cloudfront.net/image/presence/large/icon-google.png"
            alt=""
          />
          <span> GOOGLE</span>
        </Fragment>
      )
    } else if (link.site === 'other' && link.image) {
      return (
        <Fragment>
          <img style={{ height: '50px' }} src={link.image} alt="" />
          {link.site_name ? (
            <span className="text-uppercase">{link.site_name}</span>
          ) : link.site ? (
            <span className="text-uppercase">{link.site}</span>
          ) : (
            ''
          )}
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <img
            style={{ height: '50px' }}
            src={`https://dufzo4epsnvlh.cloudfront.net/image/presence/large/icon-${link.site}.png`}
            alt=""
          />
          {link.site_name ? <span>{link.site_name}</span> : link.site ? <span>{link.site}</span> : ''}
        </Fragment>
      )
    }
  }

  async handleSubmit(values, { resetForm }) {
    if (this.state.feedbackType && this.state.feedbackType === 'good' && !this.state.review.rating) {
      notification('error', 'Rating is required')
    } else {
      this.setState({ feedbackLoader: true })
      const data = {
        name: values.name ? values.name : '',
        feedback: values.feedback ? values.feedback : '',
        feedback_type: this.state.feedbackType ? this.state.feedbackType : ''
      }
      if (values && values.phone) {
        data.phone = values.phone ? values.phone : ''
      }
      if (this.state.queryData.e) {
        data.contact_email = this.state.queryData.e
      } else {
        data.contact_email = values.contact_email ? values.contact_email : ''
        if (values && values.contact_email) {
          this.setState({ clientEmail: values.contact_email })
        }
      }

      if (this.state.queryData.ph) {
        data.contact_ph = this.state.queryData.ph
        data.phone = this.state.queryData.ph
      }

      if (this.state.queryData.nxt) {
        data.next_step = true
      }
      if (this.state.queryData.r) {
        data.review_id = this.state.queryData.r
      } else if (this.state.queryData.wid) {
        data.wid = this.state.queryData.wid
      } else if (this.state.queryData.uid) {
        data.uid = this.state.queryData.uid
      } else if (this.state.queryData.pid) {
        data.pid = this.state.queryData.pid
      }

      if (this.state.review && this.state.review.rating) {
        data.rating = this.state.review.rating
      }
      const segmentData = {
        event: 'end_user_review_submitted',
        properties: {
          businessName: this.state.queryData.bn && decodeURIComponent(this.state.queryData.bn),
          rating: data.rating,
          feedback: data.feedback,
          reviewMethod: 'direct',
          endUserName: data.name,
          endUserEmail: values.contact_email
        }
      }
      await segmentEventTrack(segmentData)
      await this.props.sendReviewFeedback(data)
      if (this.props.reviewFeedback && this.props.reviewFeedback.data && this.props.reviewFeedback.data.length > 0) {
        if (this.state.newReviewsFlag) {
          await this.setState({
            message: this.props.review_settings && this.props.review_settings.review_thankyou_message,
            showForm: false,
            feedbackLoader: false
          })
        } else {
          await this.setState({
            thirdpartyLinks: this.props.reviewFeedback.data,
            showForm: false,
            feedbackLoader: false
          })
        }
      } else {
        await this.setState({
          message: this.props.review_settings && this.props.review_settings.review_thankyou_message,
          showForm: false,
          feedbackLoader: false
        })
      }
      await this.getDesign()
      if (this.props.apiError) {
        if (this.props.apiError === 'feedback already submitted') {
          await this.setState({ message: 'Sorry, the feedback link has already been used.' })
        } else {
          await this.setState({ message: this.props.apiError })
        }
        await this.setState({ showForm: false, feedbackLoader: false })
        await this.getDesign()
      }
    }
  }

  setRevieWRating(num) {
    const obj = Object.assign(this.state.review)
    if (num === 0 && this.state.review.rating === 1) {
      obj.rating = 0
    } else {
      obj.rating = num + 1
    }
    this.setState({ review: obj })
  }

  render() {
    return (
      <Fragment>
        {this.state.loaded && this.state.showNewDesign ? (
          <Fragment>
            <div className={styles['write-review']}>
              <div className={styles['write-review-content'] + ' pt-30 border'}>
                {this.state.screenType === 'smiley' ? (
                  <div>
                    <div className={styles['max-430'] + ' pb-30'}>
                      <div className="mb-20">
                        <img
                          style={{ width: '200px' }}
                          src={
                            this.props.review_settings && this.props.review_settings.logo
                              ? this.props.review_settings.logo
                              : ''
                          }
                          alt=""
                        />
                      </div>
                      <div
                        className={styles['dynamic-content-block'] + ' my-30}'}
                        dangerouslySetInnerHTML={this.createMarkup()}></div>
                      <div className="d-flex justify-content-center mt-30 mb-30">
                        <div onClick={this.happyFeedBack.bind(this)} className="cursor-pointer">
                          <div>
                            <span>
                              <img
                                src="https://gosite-assets.s3-us-west-1.amazonaws.com/image/emailer/ic-happy.png"
                                alt=""
                              />
                            </span>
                          </div>
                          <div className="mt-10 text-secondary font-weight-bold">
                            <span>VERY HAPPY</span>
                          </div>
                        </div>
                        <div onClick={this.sadFeedBack.bind(this)} className="ml-30 mr-30 cursor-pointer">
                          <div>
                            <span>
                              <img
                                src="https://gosite-assets.s3-us-west-1.amazonaws.com/image/emailer/ic-ok.png"
                                alt=""
                              />
                            </span>
                          </div>
                          <div className="mt-10 text-secondary font-weight-bold">
                            <span href="">JUST OK</span>
                          </div>
                        </div>
                        <div onClick={this.sadFeedBack.bind(this)} className="cursor-pointer">
                          <div>
                            <span>
                              <img
                                src="https://gosite-assets.s3-us-west-1.amazonaws.com/image/emailer/ic-not-happy.png"
                                alt=""
                              />
                            </span>
                          </div>
                          <div className="mt-10 text-secondary font-weight-bold">
                            <span>NOT HAPPY</span>
                          </div>
                        </div>
                      </div>
                      <div className={styles['write-review-para']}>
                        Your happiness is our priority, and we are always trying to learn more about how to deliver the
                        best experience possible. You can always{' '}
                        <a
                          href={`mailto:${this.props.review_settings && this.props.review_settings.business_email}`}
                          target="_blank"
                          rel="noopener noreferrer">
                          contact us
                        </a>{' '}
                        directly.
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.state.screenType === 'message' ? (
                  <div>
                    <div>
                      <div>
                        <img
                          style={{ height: '50px' }}
                          src={
                            this.props.review_settings && this.props.review_settings.logo
                              ? this.props.review_settings.logo
                              : ''
                          }
                          alt=""
                        />
                      </div>
                      {this.state.message ? <p>{this.state.message}</p> : ''}
                    </div>
                  </div>
                ) : null}
                {this.state.screenType === 'review-links' ? (
                  <div>
                    <div className={styles['max-430'] + ' py-30'}>
                      <div>
                        <img
                          style={{ width: '200px' }}
                          src={
                            this.props.review_settings && this.props.review_settings.logo
                              ? this.props.review_settings.logo
                              : ''
                          }
                          alt=""
                        />
                      </div>
                      {this.props.review_settings && this.props.review_settings.review_text ? (
                        <div
                          className={styles['child-fz-16'] + ' mb-15'}
                          dangerouslySetInnerHTML={this.createReviewTextMarkup()}></div>
                      ) : null}
                      {this.state.newReviewsFlag && (
                        <div
                          className={styles['dynamic-content-block'] + ' my-30}'}
                          dangerouslySetInnerHTML={this.createMarkup()}></div>
                      )}
                      <div>
                        <div className="primary-font-bold fz-16 mb-15 text-black">LEAVE A REVIEW ON:</div>
                        <div className={styles['write-review-social-btns-wrap']}>
                          {this.state.alg_data ? (
                            <button
                              className={
                                styles['write-review-social-btn'] +
                                ' border fz-12 mb-10 text-uppercase cursor-pointer primary-font-bold'
                              }
                              onClick={this.redirectToThridPartyLinks.bind(
                                this,
                                this.state.alg_data.primary_link,
                                'primary'
                              )}>
                              {this.getPrimaryLinks(this.state.alg_data)}
                            </button>
                          ) : null}
                          {this.state.alg_data &&
                            this.state.alg_data.secondary_links &&
                            this.state.alg_data.secondary_links.map((link, index) => (
                              <button
                                className={
                                  styles['write-review-social-btn'] +
                                  ' border fz-12 mb-10 text-uppercase cursor-pointer primary-font-bold'
                                }
                                key={index}
                                onClick={this.redirectToThridPartyLinks.bind(this, link, 'secondary')}>
                                {this.getSecondaryLinks(link)}
                              </button>
                            ))}
                        </div>
                      </div>

                      {this.state.newReviewsFlag && (
                        <div className={styles['write-review-para']}>
                          Your happiness is our priority, and we are always trying to learn more about how to deliver
                          the best experience possible. You can always{' '}
                          <a
                            href={`mailto:${this.props.review_settings && this.props.review_settings.business_email}`}
                            target="_blank"
                            rel="noopener noreferrer">
                            contact us
                          </a>{' '}
                          directly.
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
                {this.state.screenType === 'form' ? (
                  <div>
                    <div className={styles['max-430'] + ' pb-30'}>
                      <div className="mb-15">
                        <img
                          style={{ width: '200px' }}
                          src={
                            this.props.review_settings && this.props.review_settings.logo
                              ? this.props.review_settings.logo
                              : ''
                          }
                          alt=""
                        />
                      </div>
                      <div className="fz-22 primary-font-bold text-black mb-10">Tell us more </div>
                      <p className="fz-16 text-black mb-10">
                        We're sorry to hear you didn't have the best experience. We're always looking to improve and
                        would appreciate your feedback to help us to better serve you.
                      </p>
                      <Formik
                        validateOnChange={false}
                        validateOnBlur={false}
                        initialValues={{
                          name: '',
                          contact_email: '',
                          feedback: ''
                        }}
                        validationSchema={Yup.object().shape({
                          feedback: Yup.string().required('Required'),
                          contact_email: Yup.string().email('Invalid email')
                        })}
                        onSubmit={this.handleSubmit.bind(this)}
                        render={({ values, setFieldValue }) => {
                          return (
                            <Form name="reviewFeedbackForm" className={'pt-20'}>
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group custom-form-group-dropdown">
                                    <ErrorMessage name="name" component="span" className="form-error" />
                                    <Field
                                      className="form-control form-control-lg mb-20"
                                      type="text"
                                      placeholder="Please enter your name"
                                      name="name"
                                    />
                                  </div>
                                </div>
                                {this.state.reviewFrom &&
                                (this.state.reviewFrom === 'widget' || this.state.reviewFrom === 'phone') ? (
                                  <div className="col-12">
                                    <div className="form-group custom-form-group-dropdown">
                                      <ErrorMessage name="contact_email" component="span" className="form-error" />
                                      <Field
                                        className="form-control form-control-lg mb-20"
                                        type="text"
                                        placeholder="Please enter your email"
                                        name="contact_email"
                                      />
                                    </div>
                                  </div>
                                ) : null}
                                <div className="col-12">
                                  <div className="form-group custom-form-group-dropdown">
                                    <ErrorMessage name="feedback" component="span" className="form-error" />
                                    <Field
                                      className="form-control form-control-lg mb-20 height-100 "
                                      component="textarea"
                                      placeholder="Tell us how to do better..."
                                      name="feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                              <footer className="d-block d-sm-flex">
                                <button
                                  className={'btn btn-primary border-0 btn-xl mb-10 mb-sm-0  btn-block'}
                                  type="submit"
                                  disabled={this.state.feedbackLoader}>
                                  SEND FEEDBACK
                                  {this.state.feedbackLoader && (
                                    <i className={'btn-icon top-minus-2 mr-5 btn-loader'}>
                                      {' '}
                                      <Icon name="spinner" />
                                    </i>
                                  )}
                                </button>
                              </footer>
                            </Form>
                          )
                        }}
                      />
                    </div>
                  </div>
                ) : null}
                {this.state.screenType !== 'message' ? (
                  <div className={styles['max-540'] + ' p-30 border-top'}>
                    <div className="">
                      {this.props.review_settings && this.props.review_settings.business_name ? (
                        <div className="primary-font-bold mb-5 fz-14 text-black">
                          {this.props.review_settings.business_name}
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="fz-16 ">
                        {this.props.review_settings && this.props.review_settings.business_address ? (
                          <span className="d-block">{this.props.review_settings.business_address}</span>
                        ) : (
                          ''
                        )}
                        {this.props.review_settings && this.props.review_settings.business_website ? (
                          <a
                            className="light-text-color"
                            href={this.props.review_settings.business_website}
                            target="_blank"
                            rel="noopener noreferrer">
                            {this.props.review_settings.business_website}
                          </a>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="pt-30">
                <span className="d-inline-block mr-10">Powered by</span>
                <span>
                  <img
                    src="https://gosite-media.s3.us-west-1.amazonaws.com/uploads/58cbabbaaf8be3103d7c1968/original/8c219911-1b62-444d-a3fa-5d17b8d7a776.png"
                    alt="GoSite"
                    width="90"
                  />
                </span>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {this.state.loaded ? (
              //  <div className={styles["write-review"]}>
              //  <div className={styles["write-review-content"]+ " pt-30 border"}>
              <div>
                <div>
                  {this.state.screenType && this.state.screenType === 'smiley' ? (
                    <div className={styles['write-review-form'] + ' mx-auto rounded shadow-lg '}>
                      <div className="text-center pt-30 mb-15">
                        <img
                          style={{ maxWidth: '60px' }}
                          src={
                            this.props.review_settings && this.props.review_settings.logo
                              ? this.props.review_settings.logo
                              : ''
                          }
                          alt=""
                        />
                      </div>
                      <div className="p-30 text-center">
                        <div className={styles['give-feedback']} dangerouslySetInnerHTML={this.createMarkup()}></div>
                        <div className="mb-20 mt-10">
                          <div>
                            <button
                              onClick={this.goodFeedBack.bind(this)}
                              type="button"
                              className={styles['btn-give-feedback'] + ' btn btn-lg btn-success'}>
                              Give Feedback
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.screenType && this.state.screenType === 'form' ? (
                    <div className={styles['write-review-form'] + ' mx-auto rounded shadow-lg '}>
                      <div className="p-30 text-center">
                        <header className="mb-5">
                          <img
                            style={{ maxWidth: '60px' }}
                            src={
                              this.props.review_settings && this.props.review_settings.logo
                                ? this.props.review_settings.logo
                                : ''
                            }
                            alt=""
                          />
                        </header>
                        {this.props.review_settings && !this.props.review_settings.review_text ? (
                          <h3 className="fz-16 primary-font-bold">
                            We'd greatly appreciate <br /> an online review
                          </h3>
                        ) : null}
                        {this.props.review_settings &&
                        this.props.review_settings.review_text &&
                        this.state.feedbackType === 'good' ? (
                          <div
                            className={styles['child-p-mb']}
                            dangerouslySetInnerHTML={this.createReviewTextMarkup()}></div>
                        ) : null}
                        {this.props.review_settings &&
                        this.props.review_settings.negative_review_text &&
                        this.state.feedbackType !== 'good' ? (
                          <div
                            className={styles['child-p-mb']}
                            dangerouslySetInnerHTML={this.createNegativeTextMarkup()}></div>
                        ) : null}
                        {!this.state.showFstForm ? <p>Please leave us a review on:</p> : null}
                        {this.state.feedbackType === 'good' && this.state.showFstForm ? (
                          <figure>
                            <img src="https://dufzo4epsnvlh.cloudfront.net/image/write-review-bg.png" alt="" />
                          </figure>
                        ) : null}
                      </div>
                      <Formik
                        validateOnChange={false}
                        validateOnBlur={false}
                        initialValues={{
                          name: '',
                          contact_email: '',
                          phone: '',
                          feedback: ''
                        }}
                        validationSchema={Yup.object().shape({
                          name: Yup.string().required('Required'),
                          feedback: Yup.string().required('Required'),
                          contact_email: Yup.string().required('Required').email('Invalid email'),
                          phone: Yup.string().matches(
                            /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/,
                            'Only US phone numbers without country code are permitted.eg : (500) 555-0006'
                          )
                        })}
                        onSubmit={this.handleSubmit.bind(this)}
                        render={({ values, setFieldValue }) => {
                          return (
                            <Form name="reviewFeedbackForm" className={'p-30'}>
                              <div className={styles['reviewFeedbackForm']}>
                                {this.state.feedbackType && this.state.feedbackType === 'good' ? (
                                  <div className="layout-sm-12">
                                    <div className="d-flex p-25 rounded justify-content-center border mb-20">
                                      <span className="d-inline-block mr-15">Rate us</span>
                                      <div className={`${styles['has-td-min-width-150']}`}>
                                        {star.map((list, index) =>
                                          index < this.state.review.rating ? (
                                            <Fragment key={index}>
                                              <Tooltip position="bottom" message={list}>
                                                <i className="btn-icon ml-5 top-minus-2">
                                                  <Icon
                                                    name="starIcon"
                                                    onClick={this.setRevieWRating.bind(this, index)}
                                                  />
                                                </i>
                                              </Tooltip>
                                            </Fragment>
                                          ) : (
                                            <Fragment key={index}>
                                              <Tooltip position="bottom" message={list}>
                                                <i className={`btn-icon ml-5 top-minus-2  ${styles['star-empty']}`}>
                                                  <Icon
                                                    name="starIcon"
                                                    onClick={this.setRevieWRating.bind(this, index)}
                                                  />
                                                </i>
                                              </Tooltip>
                                            </Fragment>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="form-group custom-form-group-dropdown">
                                  <label className="label-text  text-uppercase">
                                    Your Name <span className="star">*</span>
                                  </label>
                                  <ErrorMessage name="name" component="span" className="form-error" />
                                  <Field
                                    className="form-control form-control-lg mb-20"
                                    type="text"
                                    placeholder="Please enter your name"
                                    name="name"
                                  />
                                </div>
                                {this.state.reviewFrom !== 'phone' && this.state.feedbackType !== 'good' ? (
                                  <div className="form-group custom-form-group-dropdown">
                                    <label className="label-text  text-uppercase">Your Phone</label>
                                    <ErrorMessage name="phone" component="span" className="form-error" />
                                    <Field
                                      className="form-control form-control-lg mb-20"
                                      type="text"
                                      placeholder="Please enter your phone"
                                      name="phone"
                                    />
                                  </div>
                                ) : null}

                                <div className="form-group custom-form-group-dropdown">
                                  <label className="label-text  text-uppercase">
                                    Your Email <span className="star">*</span>
                                  </label>
                                  <ErrorMessage name="contact_email" component="span" className="form-error" />
                                  <Field
                                    className="form-control form-control-lg mb-20"
                                    type="text"
                                    placeholder="Please enter your email"
                                    name="contact_email"
                                  />
                                </div>

                                <div className="form-group custom-form-group-dropdown">
                                  <label className="label-text text-uppercase">
                                    Please leave your feedback <span className="star">*</span>
                                  </label>
                                  <ErrorMessage name="feedback" component="span" className="form-error" />
                                  <Field
                                    className={styles['textareaheight'] + ' form-control form-control-lg mb-20'}
                                    style={{ height: '100px' }}
                                    component="textarea"
                                    placeholder={
                                      this.state.feedbackType === 'good'
                                        ? 'Tell others what you think about our services. Would you recommend it, and why?'
                                        : 'We are sorry to hear you had a negative experience. What can we do to improve?'
                                    }
                                    name="feedback"
                                  />
                                </div>
                              </div>
                              <footer className="d-block d-sm-flex">
                                <button
                                  style={{ borderRadius: '40px' }}
                                  className={'btn btn-primary border-0 btn-xl mb-10 mb-sm-0  btn-block'}
                                  type="submit"
                                  disabled={this.state.feedbackLoader}>
                                  SUBMIT
                                  {this.state.feedbackLoader && (
                                    <i className={'btn-icon top-minus-2 mr-5 btn-loader'}>
                                      {' '}
                                      <Icon name="spinner" />
                                    </i>
                                  )}
                                </button>
                              </footer>
                            </Form>
                          )
                        }}
                      />
                    </div>
                  ) : null}
                  {this.state.screenType && this.state.screenType === 'review-links' ? (
                    <div className={styles['write-review-form'] + ' mx-auto rounded shadow-lg '}>
                      <div className="p-30 text-center">
                        <div className="mb-15">
                          <img
                            style={{ maxWidth: '60px' }}
                            src={
                              this.props.review_settings && this.props.review_settings.logo
                                ? this.props.review_settings.logo
                                : ''
                            }
                            alt=""
                          />
                        </div>
                        {this.state.thirdpartyLinks ? (
                          <div>
                            <span className="d-block mb-15">One more step</span>
                            <h3 className="mb-30">
                              Share Your Experience on <br></br> our social profile below
                            </h3>

                            <div className="d-flex justify-content-center">
                              {this.state.thirdpartyLinks &&
                                this.state.thirdpartyLinks.map((link, index) => (
                                  <div key={index}>
                                    <div
                                      onClick={this.redirectToThridPartyLinks.bind(this, link, 'secondary')}
                                      className={
                                        styles['social-img-width'] +
                                        ' d-flex justify-content-center align-items-center border cursor-pointer mx-15'
                                      }>
                                      {link.site === 'other' && link.image ? (
                                        <img src={link.image} alt="" style={{ width: '50px', height: '50px' }} />
                                      ) : (
                                        <img
                                          src={`https://dufzo4epsnvlh.cloudfront.net/image/presence/large/icon-${link.site}.png`}
                                          alt=""
                                          style={{ width: '50px', height: '50px' }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        ) : null}
                      </div>{' '}
                    </div>
                  ) : null}
                  {this.state.screenType && this.state.screenType === 'message' ? (
                    <div className={styles['write-review-form'] + ' mx-auto rounded shadow-lg '}>
                      <div className="p-30 text-center">
                        <div className="mb-30">
                          <img
                            style={{ maxWidth: '60px' }}
                            src={
                              this.props.review_settings && this.props.review_settings.logo
                                ? this.props.review_settings.logo
                                : ''
                            }
                            alt=""
                          />
                        </div>
                        {this.state.message ? <p>{this.state.message}</p> : ''}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </Fragment>
        )}
        {!this.state.loaded ? (
          <div
            style={{ height: '100vh', width: '100vw' }}
            className="position-fixed d-flex align-items-center justify-content-center">
            <img
              src="https://dufzo4epsnvlh.cloudfront.net/image/loader-dot.svg"
              className="inline"
              alt=" "
              width="40"
            />{' '}
          </div>
        ) : null}
      </Fragment>
    )
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(reviewFeedback)
